import { useContext, useState } from "react";
import { getItems } from "@leafly-com/user-history-utils";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";

import getDispensaries from "api/requests/getFinderDispensaries";
import ConfigContext from "context/ConfigContext";
import LocationContext from "context/LocationContext";
import { Store } from "custom-types/Store";
import useOnComponentInView from "hooks/useOnComponentInView";
import { getDomainCountryCode } from "redux/selectors/config";

const RecentlyViewedCarousel = dynamic(
  () => import("./RecentlyViewedCarousel")
);

const RecentlyViewedCarouselWithData = () => {
  const { retailType, storeRoute } = useContext(ConfigContext);

  const [recentlyViewedStores, setRecentlyViewedStores] = useState<Store[]>([]);

  const { finderLocation } = useContext(LocationContext);

  const countryCode = useSelector(getDomainCountryCode);

  const [ref] = useOnComponentInView(
    async () => {
      const { coordinates } = finderLocation;

      const storedDispensaries = await getItems("dispensary", {}, 5);
      const recentlyViewedIds = storedDispensaries?.length
        ? storedDispensaries.map((entry) => entry.resourceId).filter((id) => id)
        : [];

      if (recentlyViewedIds.length) {
        const { stores } = await getDispensaries({
          countryCode,
          geo_query_type: "point",
          ids: recentlyViewedIds,
          lat: coordinates?.lat,
          lon: coordinates?.lon,
          page: 1,
          retailType,
        });

        if (stores.length) {
          setRecentlyViewedStores(
            stores.sort(
              (a, b) =>
                recentlyViewedIds.indexOf(a.id) -
                recentlyViewedIds.indexOf(b.id)
            )
          );
        }
      }
    },
    { triggerOnce: true }
  );

  return (
    <div ref={ref}>
      {recentlyViewedStores.length > 0 && (
        <RecentlyViewedCarousel
          storeRoute={storeRoute}
          stores={recentlyViewedStores}
        />
      )}
    </div>
  );
};

export default RecentlyViewedCarouselWithData;
